// extracted by mini-css-extract-plugin
export default {"other-icon":"iconHelper_other-icon__De1kK"};